import { CREATE_TWITTER_POST_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function twitterPosts(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case CREATE_TWITTER_POST_SUCCESS:
      
      
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}